import { apiReducers } from './api';
import { appReducers } from './app/index';
import { viewReducers } from './views';

export const reducers = {
  ...viewReducers,
  ...appReducers,
  ...apiReducers,
};
